module.exports = __webpack_public_path__ + "img/number_4.dbda8c70.png";